

































import PhotosViewer from "../core/Files/PhotosViewer.vue";
import { AuditApi } from "../api/AuditApi";

export default {
    name: "InterventionPhotos",
    components: {
        PhotosViewer,
    },
    props: {
        evenementHash: String,
    },
    data: function () {
        return {
            evenement: null,
            AuditApi: new AuditApi(),
        };
    },
    created() {
        let self = this;
        self.AuditApi.getEvenementByHash(self.evenementHash, {
            include: "photos,client",
        })
            .then(function (evenement) {
                self.evenement = evenement;
            })
            .catch(function (error) {
                swal({
                    title: "Erreur",
                    text: "Signalement non trouvée",
                    type: "error",
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            });
    },
    computed: {},
};
